import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a650ea7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "layout-apply-to-be-pdo container"
}

import { IProgram } from '@/types/program';
  import { onMounted, ref, provide } from 'vue';
  import { useRoute } from 'vue-router';
  import { request } from '@/utils';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const programId = route.params.id;
  const program = ref<IProgram>();
  onMounted(async () => {
    const { data } = await request.get<IProgram>(`/programs/${programId}`);
    program.value = data;
  });

  provide('program', program);


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (program.value?.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : _createCommentVNode("", true)
}
}

})